import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
	root: {
		display: "flex"
	},
	paper: {
		marginRight: theme.spacing(2),
		backgroundColor: theme.palette.background.paper
	},
	dropDown: {
		flexDirection: "column",
		zIndex: " 999!important",
		padding: "10px"
	},
	filterButton: {
		padding: "3px",
		"& .MuiToggleButton-root": {
			color: theme.palette.text.secondary,
			borderColor:
				theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.12)",
			backgroundColor: theme.palette.background.paper,
			"&:hover": {
				backgroundColor: theme.palette.action.hover
			},
			"&.Mui-selected": {
				backgroundColor:
					theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.16)" : "rgba(0, 0, 0, 0.12)",
				color: theme.palette.text.primary,
				"&:hover": {
					backgroundColor:
						theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.24)" : "rgba(0, 0, 0, 0.2)"
				}
			}
		}
	},
	transformBottom: {
		transformOrigin: "center bottom"
	},
	transformTop: {
		transformOrigin: "center top"
	},
	filterPaper: {
		backgroundColor: theme.palette.background.paper,
		"& .MuiToggleButton-root": {
			color: theme.palette.text.secondary,
			borderColor:
				theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.12)",
			"&:hover": {
				backgroundColor: theme.palette.action.hover
			},
			"&.Mui-selected": {
				backgroundColor:
					theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.16)" : "rgba(0, 0, 0, 0.12)",
				color: theme.palette.text.primary
			}
		}
	},
	filterIcon: {
		color: theme.palette.text.secondary
	},
	filterIconActive: {
		color: theme.palette.text.primary
	},
	// Couleurs d'icônes adaptées au mode sombre/clair
	iconBlack: {
		color: theme.palette.type === "dark" ? "#ffffff" : "#000000"
	},
	iconNeutral: {
		color: theme.palette.text.secondary
	},
	// Style pour les boutons de filtre actifs
	filterButtonActive: {
		backgroundColor:
			theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.16)" : "rgba(0, 0, 0, 0.12)"
	},
	// Style pour les poppers/menus dropdown
	filterDropdownPaper: {
		backgroundColor: theme.palette.background.paper,
		borderRadius: theme.shape.borderRadius,
		boxShadow: theme.shadows[3]
	},
	// Style pour les chips dans les filtres
	filterChip: {
		backgroundColor:
			theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.16)" : "rgba(0, 0, 0, 0.08)",
		color: theme.palette.text.primary,
		"&:hover": {
			backgroundColor:
				theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.24)" : "rgba(0, 0, 0, 0.12)"
		}
	},
	// Style pour les dialog de filtre
	filterDialog: {
		"& .MuiDialog-paper": {
			backgroundColor: theme.palette.background.paper
		},
		"& .MuiDialogTitle-root": {
			color: theme.palette.text.primary
		}
	}
}));
export default useStyles;
